(() => {
  const root = document.querySelector('[data-compare]');
  if (!root) return;
  const dataEl = root.querySelector('[data-compare-json]');
  const products = dataEl ? JSON.parse(dataEl.textContent) : [];
  const selects = [...root.querySelectorAll('[data-compare-select]')];
  const table = root.querySelector('[data-compare-table]');

  const fields = [
    ['price', 'Pris'],
    ['type', 'Cykeltype'],
    ['motor', 'Motor'],
    ['torque', 'Drejningsmoment'],
    ['battery', 'Batteri'],
    ['range', 'Rækkevidde'],
    ['weight', 'Vægt'],
    ['frame', 'Steltype'],
    ['wheels', 'Hjulstørrelse'],
    ['brakes', 'Bremser'],
    ['gears', 'Gear'],
    ['load', 'Maksimal belastning'],
    ['use', 'Anbefalet anvendelse']
  ];

  const byHandle = Object.fromEntries(products.map((p) => [p.handle, p]));

  const render = () => {
    const chosen = selects.map((s) => byHandle[s.value]).filter(Boolean).slice(0, 3);
    if (!chosen.length) {
      table.innerHTML = '<p>Vælg op til tre cykler for at sammenligne.</p>';
      return;
    }
    const rows = fields.filter(([,], i) => fields[i] && chosen.some((p) => p[fields[i][0]]));
    table.innerHTML = `
      <div class="table-wrap"><table>
        <thead>
          <tr>
            <th></th>
            ${chosen.map((p) => `<th><a href="${p.url}">${p.title}</a></th>`).join('')}
          </tr>
        </thead>
        <tbody>
          ${rows.map(([key, label]) => `<tr><th>${label}</th>${chosen.map((p) => `<td>${p[key] || '–'}</td>`).join('')}</tr>`).join('')}
        </tbody>
      </table></div>`;
  };

  selects.forEach((select) => select.addEventListener('change', render));
  render();
})();
